import { getCSDefault } from '../../services/workReport';

const adapterDefaultValueCS = async ({ id, body }) => {
  try {
    const res = await getCSDefault(id, body);

    return {
      idParteDiario: id,
      cost: res?.costoClase
        ? {
            costoClase: res?.costoClase?.split('-')[0],
            id: res?.costoClase,
            nombre: res?.costoClase,
            label: res?.costoClase,
            fase: res?.costoClase?.split('-')[1]
          }
        : null,
      code: res?.codigo ? { nombre: res?.codigo, id: res?.codigo, label: res?.codigo } : null,
      subCode: res?.subcodigo
        ? { nombre: res?.subcodigo, id: res?.subcodigo, label: res?.subcodigo }
        : null
    };
  } catch (error) {
    return {
      cost: null,
      code: null,
      subCode: null
    };
  }
};

export default adapterDefaultValueCS;
